import { OrgMembershipCount } from '../../graphql/generated/types';
import { TModelOptionLabels } from '../types';

export const orgMembershipCountLabels: TModelOptionLabels<OrgMembershipCount> = {
  [OrgMembershipCount.UpTo100]: '0 a 100',
  [OrgMembershipCount.From101To500]: '101 a 500',
  [OrgMembershipCount.Over500]: 'Mais de 500',
};
